export default ({ theme, variant = 'default', outline = false }) => {
	variant = typeof variant === 'string' && variant ? variant : 'default';
	if (variant === 'default' || !theme[variant]) {
		return `color: ${theme.defaultColor};
        background-color: #fff;
        border-color: #ccc;`;
	}
	return `color: ${
		outline ? theme[variant] : theme[`${variant}Color`] || '#fff'
	};
        background-color: ${outline ? '#fff' : theme[variant]};
        border-color: ${theme[variant]};
    `;
};
